
import { Component, Vue } from "vue-property-decorator";
import WechatLogin from "@/components/WechatLogin.vue";
import { GetTextAudio, GetClientInfo, CreateClient, CreateAnonymousClient } from "@/request/common";
@Component({
  components: {
    WechatLogin,
  },
})
export default class Home extends Vue {
  private showWechatLogin: boolean = false;
  private showBasicInfo: boolean = false;
  private selectedGender: string = "";
  private selectedAge: string = "";
  private selectedWeight: string = "";
  private showMoreFields: boolean = false;
  
  // 更多字段（非必填）
  private clientName: string = "";
  private idCode: string = "";
  private idCodeType: string = "";
  private birthDate: string = "";
  private phone: string = "";

  private genderOptions = ["男", "女"];
  private ageOptions = ["儿童", "青少年", "中年", "老年"];
  private weightOptions = ["偏瘦", "正常", "超重", "肥胖"];
  private idCodeTypeOptions = ["身份证", "医保卡", "学生证", "士兵证", "护照", "体检卡", "其它"];
  private currentAudio: any = null;
  private goToReport() {
    this.$router.push({
      path: "/report",
      query: {
        report_id: "109",
        ifCanReturn: 'true'
      },
    });
  }

  private onTongueClick() {
    // 每次开始体验都先走微信登录；基本信息仅在登录成功后由 showBasicInfoDialog 弹出
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio = null;
    }
    this.showBasicInfo = false;
    this.showWechatLogin = true;
  }

  private async handleClientInfo() {
    try {
      console.log("handleClientInfo开始执行");
      // 获取user_id
      const userInfo = this.$store.state.userInfo;
      let userId = userInfo?.user || userInfo?.user_id;

      console.log("从store获取的userInfo:", userInfo);
      console.log("从store获取的userId:", userId);

      // 如果store中没有user_id，尝试从localStorage获取
      if (!userId) {
        userId = localStorage.getItem("user_id");
        console.log("从localStorage获取的userId:", userId);
      }

      if (!userId) {
        console.log('用户信息不完整');
        // 用户信息不完整，直接打开微信登录
        // this.showWechatLogin = true;
        return;
      }

      console.log("开始查询client，userId:", userId);
      // 先查询client是否存在
      const clientParams = {
        params: {
          user_id: userId,
        },
      };

      const clientRes = await GetClientInfo(this, clientParams);
      const clientResult = clientRes.data;

      console.log("查询client结果:", clientResult);

      if (clientResult && clientResult.length > 0) {
        // 如果client存在，自动填充基本信息
        const client = clientResult[0];
        this.$store.commit("setClientInfo", client);
        this.selectedGender = client.gender || "";
        this.selectedAge = client.age_group || "";
        this.selectedWeight = client.weight_group || "";
        // 填充更多字段
        this.clientName = client.name || "";
        this.idCode = client.id_code || "";
        this.idCodeType = client.id_code_type || "";
        this.birthDate = client.birth_date || "";
        this.phone = client.phone || "";

        console.log("自动填充的基本信息:", {
          gender: this.selectedGender,
          age: this.selectedAge,
          weight: this.selectedWeight,
        });
        // 不再自动跳转，直接弹出确认信息弹框
      } else {
        // 如果client不存在，创建新的client
        const createParams = {
          user_id: userId,
        };

        console.log("创建新client，参数:", createParams);
        const newClient = await CreateClient(this, createParams);
        this.$store.commit("setClientInfo", newClient);
        console.log("创建client成功");
        // 新建client时不自动选中
        this.selectedGender = "";
        this.selectedAge = "";
        this.selectedWeight = "";
        // 重置更多字段
        this.clientName = "";
        this.idCode = "";
        this.idCodeType = "";
        this.birthDate = "";
        this.phone = "";
      }

      console.log("弹出基本信息确认框");
      console.log("store中的clientInfo:", this.$store.state.clientInfo);
      console.log("store中的userInfo:", this.$store.state.userInfo);

      // 先获取音频，显示加载状态
      const loading = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      try {
        // 等待getTextAudio完成
        const audioUrl = await this.getTextAudio("请确认您的基本信息。");

        // 关闭加载状态
        loading.clear();

        // 音频获取成功后再打开弹框
        this.showBasicInfo = true;

        // 播放音频
        this.currentAudio = new Audio(audioUrl);
        this.currentAudio.play();
        this.currentAudio.addEventListener("ended", () => {
          this.currentAudio = null;
        });
      } catch (error) {
        // 关闭加载状态
        loading.clear();
        console.error("获取音频失败:", error);
        this.$toast.fail("获取音频失败，请重试");
      }
    } catch (error) {
      console.error("处理client信息失败:", error);
      this.$toast.fail("获取用户信息失败，请重试");
    }
  }

  private async getTextAudio(text: string): Promise<string> {
    return new Promise((resolve, reject) => {
      GetTextAudio(this, {
        text: text,
      })
        .then((res: any) => {
          const base64Data = res.data;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "audio/mp3" });
          const url = URL.createObjectURL(blob);
          resolve(url);
        })
        .catch(() => {
          reject();
        });
    });
  }

  private handleBasicInfoCancel() {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio = null; // 清空 currentAudio
    }
    this.showBasicInfo = false;
    // 重置更多字段的展开状态
    this.showMoreFields = false;
  }

  private async handleBasicInfoConfirm() {
    console.log("完成");
    if (!this.selectedGender || !this.selectedAge || !this.selectedWeight) {
      this.$toast("请完成所有必填选项");
      return;
    }

    // 只做跳转和本地数据处理，不再调用CreateClient
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio = null; // 清空 currentAudio
    }
    this.showBasicInfo = false;
    // 将基本信息传递到采集页面
    const query: any = {
      gender: this.selectedGender,
      age: this.selectedAge,
      weight: this.selectedWeight,
    };
    
    // 添加更多字段（如果有值）
    if (this.clientName) query.name = this.clientName;
    if (this.idCode) query.id_code = this.idCode;
    if (this.idCodeType) query.id_code_type = this.idCodeType;
    if (this.birthDate) query.birth_date = this.birthDate;
    if (this.phone) query.phone = this.phone;
    
    this.$router.push({
      path: "/caiji",
      query,
    });
  }

  private handleLoginClose() {
    this.showWechatLogin = false;
    // 检查是否有重定向参数
    const redirect = this.$route.query.redirect as string;
    if (redirect) {
      // 如果有重定向参数，直接跳转
      this.$router.push(redirect);
    }
    // 没有重定向参数时，不做任何操作
  }

  private goToICP() {
    window.open("https://beian.miit.gov.cn/", "_blank");
  }

  private async showBasicInfoDialog() {
    // 确保微信登录弹框已关闭，再拉取 client 并展示基本信息
    this.showWechatLogin = false;
    await this.handleClientInfo();
  }

  private mounted() {
    // const audio: any = new Audio(
    //   "https://cjweb.oss-cn-shanghai.aliyuncs.com/szr/kacha.mp3"
    // );
    // audio.play();
  }
}
